module.exports = __webpack_public_path__ + "img/blankdualscreen_1000.b33ad9e9.png";